import type * as ents from '@attain-apps/entities'
import type * as rxjs from 'rxjs'

import * as gql from '../../gql'

/**
 * API for the Lab Service's Auto Lab Based functionalizations.
 */
export class Api {
  /** Gets the functionalizations calculated from the given lab records. */
  public get(
    context: Api.Context,
  ): rxjs.Observable<ents.extra.space.Functionalization[]> {
    return gql.queries.calculatedSpaceRecordFunctionalizations.executor(context)
  }
}

export namespace Api {
  /** Scenario context, with the lab records to calculate from */
  export type Context = ents.core.admin.Context.ForScenario & {
    readonly spaceRecordIds: readonly ents.core.dms.data.Record.Id[]
  }
}
